import { isArrayWithItems as T } from "../../../helpers/array-helper.js";
import "react/jsx-runtime";
import "dayjs";
const g = 21, N = 150, F = 250, I = 350, h = (e) => [
  {
    type: "checkbox",
    label: e("FIND_STATION_PREEM_MANNED"),
    name: "stationType",
    value: "01 Bemannad",
    group: "services"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_SERVICE_TRAILER_RENTAL"),
    name: "trailerRental",
    value: !0,
    group: "services"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_SERVICE_FOOD_AND_BEVERAGES"),
    name: "foodAndBeverages",
    value: !0,
    group: "services"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_SERVICE_CAR_WASH_AUTOMATIC"),
    name: "carWashAutomatic",
    value: !0,
    group: "services"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_SERVICE_CAR_WASH_SELF_SERVICE"),
    name: "carWashSelfService",
    value: !0,
    group: "services"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_SERVICE_ESPRESSO_HOUSE"),
    name: "espressoHouse",
    value: !0,
    group: "services"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_SERVICE_ADAPTED_FOR_24M_VEHICLE"),
    name: "adaptedFor24mVehicles",
    value: !0,
    group: "services"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_PREEM_REDEFINE_HVO100_LIGHT_VEHICLE"),
    name: "fuelTypesPreemRedefineHVO100LattTrafikPersonbil",
    value: "PreemRedefineHVO100LattTrafikPersonbil",
    group: "propellants",
    sortOrder: 10
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_PREEM_REDEFINE_HVO100_HEAVY_VEHICLE"),
    name: "fuelTypesHVO100PreemRedefineHVO100TungTrafik",
    value: "PreemRedefineHVO100TungTrafik",
    group: "propellants",
    sortOrder: 10
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_HVO100_LIGHT_VEHICLE"),
    name: "fuelTypesHVO100LattTrafikPersonbil",
    value: "HVO100LattTrafikPersonbil",
    group: "propellants",
    sortOrder: 10
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_HVO100_HEAVY_VEHICLE"),
    name: "fuelTypesHVO100TungTrafik",
    value: "HVO100TungTrafik",
    group: "propellants",
    sortOrder: 20
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_ETANOL_E85"),
    name: "fuelTypesEtanolE85",
    value: "EtanolE85",
    group: "propellants"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_BENSIN_95"),
    name: "fuelTypesBensin95",
    value: "Bensin95",
    group: "propellants"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_BENSIN_98"),
    name: "fuelTypesBensin98",
    value: "Bensin98",
    group: "propellants"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_EVOLUTION_BENSIN_95"),
    name: "fuelTypesEvolutionBensin95",
    value: "EvolutionBensin95",
    group: "propellants"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_PREEM_EVOLUTION_DIESEL_FRI_FRAN_RME"),
    name: "fuelTypesPreemEvolutionDieselFriFranRME",
    value: "PreemEvolutionDieselFriFranRME",
    group: "propellants"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_PREEM_EVOLUTION_DIESEL"),
    name: "fuelTypesPreemEvolutionDiesel",
    value: "PreemEvolutionDiesel",
    group: "propellants"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_ACP_DIESEL"),
    name: "fuelTypesACPDiesel",
    value: "ACPDiesel",
    group: "propellants"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_ACP_DIESEL_50"),
    name: "fuelTypesACPDiesel50",
    value: "ACPDiesel50",
    group: "propellants"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_FORDONGAS"),
    name: "fuelTypesFordongas",
    value: "Fordongas",
    group: "propellants"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_AD_BLUE"),
    name: "fuelTypesAdBlue",
    value: "AdBlue",
    group: "propellants"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_EV_CONNECTOR_STANDARD_CCS"),
    name: "chargingStandardCCS",
    value: "CCS",
    group: "electricCharging",
    subgroup: "chargerStandard"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_EV_CONNECTOR_STANDARD_CHADEMO"),
    name: "chargingStandardCHAdeMO",
    value: "CHAdeMO",
    group: "electricCharging",
    subgroup: "chargerStandard"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_FUEL_EV_CONNECTOR_STANDARD_TYPE2"),
    name: "chargingStandardType2",
    value: "Type2",
    group: "electricCharging",
    subgroup: "chargerStandard"
  },
  {
    type: "slider",
    labels: [
      `≥ ${g} kW`,
      `${N} kW`,
      `${F} kW`,
      `≥ ${I} kW`
    ],
    name: "chargingPowerSlider",
    group: "electricCharging",
    subgroup: "chargerPower",
    min: 0,
    max: 3
  }
], C = (e) => [
  {
    type: "checkbox",
    label: e("FIND_STATION_PREEM_MANNED"),
    name: "stationType",
    value: "01 Bemannad",
    group: "services"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_SERVICE_TRAILER_RENTAL"),
    name: "trailerRental",
    value: !0,
    group: "services"
  },
  {
    type: "checkbox",
    label: e("FIND_STATION_SERVICE_CAR_WASH_BOTH"),
    name: "bothCarWash",
    value: !0,
    group: "services"
  }
], f = (e) => {
  switch (e) {
    case 0:
      return g;
    case 1:
      return N;
    case 2:
      return F;
    case 3:
      return I;
    default:
      return 0;
  }
}, L = [
  {
    groupName: "electricCharging",
    filterFunction: (e, l) => {
      const s = l.filter((r) => r.group === "electricCharging"), i = s.find((r) => r.name === "chargingPowerSlider"), t = i ? parseInt(i.value) : 0, a = f(t), o = ["chargingStandardCCS", "chargingStandardType2", "chargingStandardCHAdeMO"], n = s.filter(
        (r) => o.includes(r.name)
      );
      return e.filter((r) => {
        if (!T(r.electricConnectors))
          return !1;
        let u = !1;
        if (T(n))
          for (const _ of n) {
            const c = _.value, E = r.electricConnectors.find(
              (p) => p?.standard?.toLocaleLowerCase() === c?.toLowerCase()
            );
            if (E) {
              const p = E.power;
              parseInt(p) >= a && (u = !0);
            }
          }
        else
          for (const _ of r.electricConnectors) {
            const c = parseInt(_.power);
            if (!isNaN(c) && c >= a) {
              u = !0;
              break;
            }
          }
        return u;
      });
    }
  },
  {
    groupName: "propellants",
    filterFunction: (e, l) => {
      const s = l.filter((t) => t.group === "propellants");
      return e.filter((t) => {
        const a = t.fuelTypes;
        let o = !1;
        for (const n of s)
          a.find(
            (r) => r.name.toLowerCase() === n.value.toLowerCase()
          ) && (o = !0);
        return o;
      });
    }
  },
  {
    groupName: "services",
    filterFunction: (e, l) => {
      const s = l.filter((t) => t.group === "services");
      return e.filter((t) => {
        for (const a of s) {
          const o = A.find(
            (n) => n.propertyName === a.name
          );
          if (o) {
            if (!o.filterFunction(t))
              return !1;
          } else if (t[a.name].toString() !== a.value)
            return !1;
        }
        return !0;
      });
    }
  }
], A = [
  {
    propertyName: "bothCarWash",
    filterFunction: (e) => e.carWashAutomatic || e.carWashSelfService
  }
];
export {
  L as customFilterGroupResolvers,
  h as getFindStationFilters,
  C as getFindStationQuickFilters,
  f as getMinChargingWattageFromSetting
};
